import React, { useState } from "react";
import "./Confirm_Addess_Modal.css";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { faBasketShopping, faBuilding, faX, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Green_Btn from "../../common_btn/green_btn/Green_Btn";
import Gray_Btn from "../../common_btn/gray_btn/Gray_Btn";

function Confirm_Addess_Modal(props) {

    const navigate = useNavigate()
    const [addCartBTNShow, setaddCartBTNShow] = useState(false);

    return (
        <>
            <section className="modal-holder">
                <Modal
                    {...props}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className="Confirm_Addess_Modal modal-holder"
                >

                    <Modal.Header>
                        <div className="title_text">
                            <p>Confirm Delivery Address</p> 
                        </div>

                        <div className="right_side">
                            <img src="/assets/images/cart/close.png" className="close_img" onClick={() => { props?.onHide() }} />
                        </div>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="address_holder">

                            <p className="type_text"> <FontAwesomeIcon icon={faBuilding} className="inner_icon" /> Apartment</p>

                            <p className="address_text">Shivkrupa Colony, Alkapuri Society, Kothrud, Pune, Maharashtra, 411038</p>

                            <div className="btns_holder">
                                <Gray_Btn btn_name="Update Address" onClick={() => {navigate("/saved-address")}}/>
                                <Green_Btn btn_name="Proceed" onClick={() => {navigate("/checkout")}}/>
                            </div>

                        </div>
                    </Modal.Body>

                </Modal>


            </section>
        </>
    );
}

export default Confirm_Addess_Modal;
